import '../../shared/tracking/globalTracking';
import '../../shared/overflowExpandableController';
import '../../shared/controllers/showMoreController';
import '../../shared/controllers/expansionController';
import '../../shared/controllers/tooltipController';
import '../../b2c/directory/bookableTimes';
import '../../b2c/directory/nonApiBookableTimes';
import { loadMap } from '../../b2c/directory/mapbox_map';

import './controllers/columnListController';
import './controllers/explandable_self_pay/expandableSelfPayCardController';
import './controllers/explandable_self_pay/showMoreController';
import './sliders';

import { Modal } from './components/modal';
import { setUpGeolocation } from '@/components/b2c/directory/browserGeolocation';

loadMap();

new Modal('.share-modal__container').mount();
new Modal('.cityselect-modal__container').mount();

if (
  document.body.id === 'b2c-groups-show' &&
  document.body.dataset.route === 'group'
) {
  setUpGeolocation();
}

/**
 *  State / City links
 */

const stateButtons = document.querySelectorAll('[data-modal-state-button]');
const allStateDivs = document.querySelectorAll('[data-modal-state]');
stateButtons.forEach((button) => {
  button.addEventListener('click', (e) => {
    const stateName = button.dataset.modalStateButton;
    const stateDiv = document.querySelector(
      `[data-modal-state="${stateName}"]`,
    );
    if (stateDiv.dataset.opened === 'true') {
      stateDiv.dataset.opened = 'false';
    } else if (stateDiv.dataset.opened === 'false') {
      stateDiv.dataset.opened = 'true';
    }
    allStateDivs.forEach((div) => {
      if (div !== stateDiv) {
        div.dataset.opened = 'false';
      }
    });
  });
});

/**
 * Set up page nav functionality
 */
const pageNav = document.querySelector('.group-page-nav');
const pageNavLinks = Array.from(
  document.querySelectorAll('[data-intra-page-link]'),
);
const linkRef = {};
let activeLink;

pageNavLinks.forEach((el) => {
  const targetSectionId = el.getAttribute('href').slice(1);
  linkRef[targetSectionId] = el;
});

const groupCardEl = document.querySelector('.group-card');

const groupCardObserverOptions = {
  rootMargin: '10px',
  threshold: 0.02,
};

const groupCardObserver = new IntersectionObserver((entries, observer) => {
  const { isIntersecting } = entries[0];
  pageNav.dataset.isPinned = isIntersecting ? 'false' : 'true';
}, groupCardObserverOptions);

groupCardObserver.observe(groupCardEl);

const sectionObserverTargetOptions = {
  rootMargin: '0px',
  threshold: 0.25,
};

const handlePageNavUpdates = (entries, observer) => {
  const { intersectionRatio, target } = entries[0];

  if (intersectionRatio >= sectionObserverTargetOptions.threshold) {
    if (activeLink) {
      activeLink.classList.remove('active');
    }
    const activeSection = target.id;
    const linkToActivate = linkRef[activeSection];
    activeLink = linkRef[activeSection];

    linkToActivate.classList.add('active');
  }
};

document
  .querySelectorAll('[data-intersection-observer-target]')
  .forEach((el) => {
    const observer = new IntersectionObserver(
      handlePageNavUpdates,
      sectionObserverTargetOptions,
    );
    observer.observe(el);
  });
